import { put, takeLatest, call } from "redux-saga/effects";
import ConfiguracionActions, {
  Types as ConfiguracionTypes,
} from "../../stores/configuracion/Actions";
import ConfiguracionService from "../../services/configuracion/ConfiguracionService";
import ResponseCode from "../../services/ResponseCode";

function* consultarCargaPantallas() {
  yield put(ConfiguracionActions.consultarCargaPantallasLoading());

  const response = yield call(ConfiguracionService.consultarCargaPantallas);

  if (!response?.respuesta) {
    yield put(
      ConfiguracionActions.consultarCargaPantallasFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code) {
    yield put(
      ConfiguracionActions.consultarCargaPantallasFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (response?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      ConfiguracionActions.consultarCargaPantallasFailure(response?.respuesta)
    );
    return;
  }

  yield put(
    ConfiguracionActions.consultarCargaPantallasSuccess(response)
  );
}

const exportedArray = [
  takeLatest(ConfiguracionTypes.CONSULTAR_CARGA_PANTALLAS, consultarCargaPantallas),
];

export default exportedArray;

